import React, { useMemo } from 'react'
import PredictionSummary from './PredictionSummary'
import { categorizePredictions, normalizePredictionData } from './predictionView.util';
import { Box } from '@mui/material';
import PredictionCard from './PredictionCard';
import { NormalizedPredictionKind } from './enums';
import PredictionHeading from './PredictionHeading';

const PredictionView = ({ predictionData, user, filter }) => {

  const { conditionType, predictionType, category, month, day } = filter;

  const { userCurrentTimezone } = user;

  const summary = useMemo(() => {
    return predictionData?.summary
  }, [predictionData])

  const beforeMoonChangeSummary = useMemo(() => {
    return predictionData?.moonChangeSummaries?.beforeMoonChange
  }, [predictionData])

  const afterMoonChangeSummary = useMemo(() => {
    return predictionData?.moonChangeSummaries?.afterMoonChange
  }, [predictionData])


  const normalized = useMemo(
    () => normalizePredictionData(predictionData),
    [predictionData]
  );

  const predictions = useMemo(() => {
    if (normalized.type === NormalizedPredictionKind.NORMAL) {
      const predictions = categorizePredictions(normalized?.predictions);
      return predictions
    }
  }, [normalized]);

  const beforeMoonChangePredictions = useMemo(() => {
    if (normalized.type === NormalizedPredictionKind.MOON_CHANGE) {
      const predictions = categorizePredictions(normalized?.before?.predictions);
      return predictions
    }
  }, [normalized]);

  const afterMoonChangePredictions = useMemo(() => {
    if (normalized.type === NormalizedPredictionKind.MOON_CHANGE) {
      const predictions = categorizePredictions(normalized?.after?.predictions);
      return predictions
    }
  }, [normalized]);


  const beforeMoonChangePredictionsTitle = useMemo(() => {
    return beforeMoonChangePredictions?.length && afterMoonChangePredictions?.length ? 'Before Moon Change Predictions' : 'Predictions'
  }, [beforeMoonChangePredictions, afterMoonChangePredictions])

  const afterMoonChangePredictionsTitle = useMemo(() => {
    return beforeMoonChangePredictions?.length && afterMoonChangePredictions?.length ? 'After Moon Change Predictions' : 'Predictions'
  }, [beforeMoonChangePredictions, afterMoonChangePredictions])

  return (
    <Box sx={{py: 1}}>
      {/* Normal predictuon */}
      {summary && (
        <PredictionSummary
          title='Summary'
          summary={summary}
        />
      )}

      {predictions && predictions.length > 0 && predictions.map(({ category, predictions }) => (
        <PredictionCard
          key={category}
          category={category}
          predictions={predictions}
          userCurrentTimezone={userCurrentTimezone}
          predictionType={predictionType}
          conditionType={conditionType}
        />
      ))}

      {/* Before moon change predictuon */}
      {beforeMoonChangeSummary && (
        <PredictionSummary
          title={beforeMoonChangeSummary && afterMoonChangeSummary ? 'Before Moon Change Summary' : 'Summary'}
          summary={beforeMoonChangeSummary}
        />
      )}


      {beforeMoonChangePredictions && beforeMoonChangePredictions.length > 0  &&  
          <PredictionHeading title={beforeMoonChangePredictionsTitle} />
      }
      {beforeMoonChangePredictions && beforeMoonChangePredictions.length > 0 && beforeMoonChangePredictions.map(({ category, predictions }) => (
          <PredictionCard
            key={category}
            category={category}
            predictions={predictions}
            userCurrentTimezone={userCurrentTimezone}
            predictionType={predictionType}
            conditionType={conditionType}
          />
      ))}


      {/* Normal predictuon */}
      {afterMoonChangeSummary && (
        <PredictionSummary
          title={beforeMoonChangeSummary && afterMoonChangeSummary ? 'After Moon Change Summary' : 'Summary'}
          summary={afterMoonChangeSummary}
        />
      )}

      {afterMoonChangePredictions && afterMoonChangePredictions.length > 0 && 
          <PredictionHeading title={afterMoonChangePredictionsTitle} />
      }
      {afterMoonChangePredictions && afterMoonChangePredictions.length > 0 && afterMoonChangePredictions.map(({ category, predictions }) => (
          <PredictionCard
            key={category}
            category={category}
            predictions={predictions}
            userCurrentTimezone={userCurrentTimezone}
            predictionType={predictionType}
            conditionType={conditionType}
          />
      ))}
    </Box>
  )
}

export default PredictionView


